<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Model from "@/services/models/correspondences";
import api from "../../../services/api";
import {dateToString, truncate} from "@/helpers/utils";
import CorrespondenceDetails from "../../../components/correspondences/correspondence-details";
import CorrespondenceForm from "../../../components/correspondences/correspondence-form";
import PersonInline from "../../../components/persons/person-inline";
import PersonDetails from "../../../components/persons/person-details";


export default {
  page: {
    title: "Correspondances",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    CorrespondenceForm,
    CorrespondenceDetails,
    PersonInline,
    PersonDetails,
    Layout,
    PageHeader
  },
  data() {
    const canEdit = !!JSON.parse(localStorage.getItem('user')).roles.find((v) => v.name === 'admin');

    return {
      title: "Correspondances",
      items: [
        {
          text: "Correspondances",
          active: true
        },
        {
          text: "Liste",
          active: true
        }
      ],
      canEdit,
      modalTitle: '',
      selectedCorres: null,
      selectedPerson: null,
      isBusy: false,
      displayDetails: false,
      displayEditForm: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        {key: "code_correspondence", sortable: true, label: '#'},
        {key: "departure", sortable: true, label: 'Expéditeur'},
        {key: "destination", sortable: true, label: 'Destinataire'},
        {key: "date", sortable: true, label: 'Date'},
        {key: "subject", sortable: true, label: 'Sujet'},
        {key: "persons", sortable: true, label: 'Personnalité(s)'},
        //{key: "typescript_manuscript", sortable: true, label: 'Type', class: "text-center"},
        {key: "letter_type", sortable: true, label: 'Type de lettre', class: "text-center"},
        //{key: "format", sortable: true, label: 'Format', class: "text-center"},
        //{key: "attachment", sortable: true, label: 'PJ', class: "text-center"},
        {key: "actions", sortable: false, class: 'text-center'},
      ],
      timeout: null,
      advanced: {},
      author: null,
      recipient: null,
      data: []
    };
  },
  mounted() {
    this.myProvider();
  },
  methods: {
    myProvider() {
      this.isBusy = true;

      return api.getModels(Model, {
        params: {
          page: this.currentPage,
          length: this.perPage,
          filter: this.filter,
          sortBy: this.sortBy,
          sortDir: (this.sortDesc ? 'desc' : 'asc'),
          with: 'date,persons,letter_type,document_type,author,recipient',
          advanced: this.advanced
        },
        identifier: 'provider'
      }).then((response) => {
        this.data = response.data.data;
        this.totalRows = response.data.total;
      }).catch(() => {
        this.data = [];
        this.totalRows = 0;
      }).finally(() => {
        this.isBusy = false;
      });
    },
    hideModal() {
      this.displayDetails = false;
      this.displayEditForm = false;
      this.selectedCorres = null;
      this.modalTitle = '';

      this.$bvModal.hide('modal-details');
      this.myProvider();
    },
    showDetails(item) {
      this.displayDetails = true;
      this.displayEditForm = false;
      this.selectedCorres = item;
      this.modalTitle = `Détail correspondance`;
    },
    showEditForm(item) {
      this.displayDetails = false;
      this.displayEditForm = true;
      this.selectedCorres = item;
      this.modalTitle = `Edition correspondance`;
    },
    displayDate(date) {
      return dateToString(date);
    },
    displaySubject(correspondence) {
      return truncate(correspondence.subject, 40, '...');
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
  },
  watch: {
    author(v) {
      if (!v) {
        delete this.advanced.author;
      }

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.currentPage = 1;
        this.advanced.author = v;
        this.myProvider();
      }, 500);

    },
    recipient(v) {
      if (!v) {
        delete this.advanced.recipient;
      }

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.currentPage = 1;
        this.advanced.recipient = v;
        this.myProvider();
      }, 500);
    },
    currentPage() {
      this.myProvider();
    },
    filter() {
      this.data = [];
      this.currentPage = 1;
      this.myProvider();
    },
    sortBy() {
      this.data = [];
      this.currentPage = 1;
      this.myProvider();
    },
    sortDesc() {
      this.data = [];
      this.currentPage = 1;
      this.myProvider();
    },
    perPage() {
      this.data = [];
      this.currentPage = 1;
      this.myProvider();
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row my-4">
              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Afficher&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;enregistrements
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-4">
                <b-row>
                  <b-col>
                    <b-form-group label="Expéditeur">
                      <b-form-input v-model="author" type="text"></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group label="Destinataire">
                      <b-form-input v-model="recipient" type="text"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>

              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_filter" class="dataTables_filter text-right">
                  <label class="d-inline-flex align-items-center">
                    Recherche :
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Recherche..."
                        class="form-control-sm w-auto"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  ref="correspondences_table"
                  :items="data"
                  :fields="fields"
                  :busy="isBusy"
                  striped
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  stacked="sm"
                  small
              >

                <template #cell(subject)="data">
                  {{ displaySubject(data.item) }}
                </template>
                <template #cell(date)="data">
                  {{ data.item.date ? displayDate(data.item.date) : '' }}
                </template>
                <template #cell(departure)="data">
                  <div v-b-modal.modal-person @click="selectedPerson = data.item.author">
                    <person-inline v-if="data.item.author" :value="data.item.author"></person-inline>
                  </div>
                  <div class="badge badge-soft-secondary text-primary" v-if="data.item.location_departure">
                    {{ data.item.location_departure === 'inconnu' ? '' : data.item.location_departure }}
                  </div>
                </template>
                <template #cell(destination)="data">
                  <div v-b-modal.modal-person @click="selectedPerson = data.item.recipient">
                    <person-inline :value="data.item.recipient"></person-inline>
                  </div>
                  <div class="badge badge-soft-secondary text-primary" v-if="data.item.location_destination">
                    {{ data.item.location_destination === 'inconnu' ? '' : data.item.location_destination }}
                  </div>
                </template>
                <template #cell(attachment)="data">
                  <i class="bx bx-paperclip label-icon" v-if="data.item.attachment !== ''"></i>
                </template>
                <template #cell(letter_type)="data">
                  {{ data.item.letter_type ? capitalizeFirstLetter(data.item.letter_type.name) : '' }}
                </template>
                <template #cell(format)="data">
                  {{ data.item.document_type ? data.item.document_type.name : '' }}
                </template>

                <template #cell(persons)="data">
                  <div v-if="data.item.persons">
                    <div class="me-1 d-inline-block"
                         v-for="(person, i) in data.item.persons"
                         :key="i"
                         v-b-modal.modal-person
                         @click="selectedPerson = person"
                    >
                      <person-inline :value="person"></person-inline>
                    </div>
                  </div>
                </template>

                <template #cell(actions)="data">
                  <ul class="list-inline font-size-20 contact-links mb-0">
                    <li class="list-inline-item text-info">
                      <a v-b-modal.modal-details @click="showDetails(data.item)"
                         title="Afficher">
                        <i class="bx bx-show"></i>
                      </a>
                    </li>
                    <li v-if="canEdit" class="list-inline-item text-warning">
                      <a v-b-modal.modal-details @click="showEditForm(data.item)"
                         title="Modify">
                        <i class="bx bx-pencil"></i>
                      </a>
                    </li>
                  </ul>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
              <div class="col">
                <div class="float-end">
                  <strong>{{ totalRows }}</strong> enregistrements
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-details" :title-html="this.modalTitle" centered hide-footer
             size="lg"
             title-class="font-18"
             @hide="hideModal">
      <correspondence-details v-if="displayDetails" :resource="this.selectedCorres"></correspondence-details>

      <template v-if="canEdit">
        <correspondence-form v-if="displayEditForm" :correspondence="this.selectedCorres" v-on:cancel="hideModal"
                             v-on:submitted="hideModal"></correspondence-form>
      </template>
    </b-modal>

    <b-modal id="modal-person" centered hide-footer
             size="xl"
             title-class="font-18"
             @hide="selectedPerson = null">
      <person-details v-if="selectedPerson" :person="selectedPerson"></person-details>
    </b-modal>
  </Layout>
</template>